import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import i18n from './i18n'
Vue.use(Vuetify)

const theme = {
    primary: '#333333',
    secondary: '#9C27b0',
    accent: '#9C27b0',
    info: '#00CAE3',
}
import en from 'vuetify/es5/locale/en'
export default new Vuetify({
    lang: {
        locales: { en }
        // t: (key, ...params) => i18n.t(key, params),
    },
    theme: {
        themes: {
            // dark: theme,
            light: theme,
        },
    },
})
